import { render, staticRenderFns } from "./sidenav.pug?vue&type=template&id=0d61c057&lang=pug&"
import script from "./sidenav.js?vue&type=script&lang=js&"
export * from "./sidenav.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/macmaum1/Desktop/GARAJE/mavalue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d61c057')) {
      api.createRecord('0d61c057', component.options)
    } else {
      api.reload('0d61c057', component.options)
    }
    module.hot.accept("./sidenav.pug?vue&type=template&id=0d61c057&lang=pug&", function () {
      api.rerender('0d61c057', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/extraInfoLayout/components/sidenav/index.vue"
export default component.exports